export const guaranteedCareService = {
  isNotGuaranteedZip(zip: string): boolean {
    return guaranteedCareZips.indexOf(parseInt(zip)) === -1;
  },

  isNotGuaranteedHospital(hospital: string): boolean {
    return guaranteedCareHospitals.indexOf(hospital) === -1;
  },
};

// Source: https://swisspost.opendatasoft.com/explore/dataset/plz_verzeichnis_v2
const guaranteedCareZips: number[] = [
  // Basel-Stadt
  4000, // Basel
  4001, // Basel
  4002, // Basel Bahnhof
  4003, // Basel
  4004, // Basel
  4005, // Basel
  4007, // Basel
  4009, // Basel
  4010, // Basel
  4011, // Basel
  4012, // Basel
  4013, // Basel
  4014, // Basel CIRCLE
  4015, // Basel
  4016, // Basel
  4017, // Basel
  4018, // Basel
  4019, // Basel
  4020, // Basel
  4021, // Basel Sort
  4024, // Basel
  4025, // Basel
  4028, // Basel
  4030, // Basel
  4031, // Basel
  4032, // Basel
  4033, // Basel
  4034, // Basel 34 Breite
  4035, // Basel
  4036, // Basel CALL
  4039, // Basel SSF
  4041, // Basel
  4051, // Basel
  4052, // Basel
  4053, // Basel
  4054, // Basel
  4055, // Basel
  4056, // Basel
  4057, // Basel
  4058, // Basel
  4059, // Basel
  4070, // Basel
  4075, // Basel
  4089, // Basel
  4091, // Basel
  4126, // Bettingen
  4125, // Riehen

  // Basel-Landschaft
  4147, // Aesch (BL)
  4123, // Allschwil
  4469, // Anwil
  4424, // Arboldswil
  4422, // Arisdorf
  4144, // Arlesheim
  4302, // Augst
  4431, // Bennwil
  4105, // Biel-Benken
  4102, // Binningen
  4127, // Birsfelden
  4223, // Blauen
  4461, // Böckten
  4103, // Bottmingen
  4207, // Bretzwil
  4225, // Brislach
  4101, // Bruderholz
  4416, // Bubendorf
  4446, // Buckten
  4117, // Burg im Leimental
  4463, // Buus
  4457, // Diegten
  4442, // Diepflingen
  4243, // Dittingen
  4202, // Duggingen
  4458, // Eptingen
  4107, // Ettingen
  4402, // Frenkendorf
  4414, // Füllinsdorf
  4460, // Gelterkinden
  4304, // Giebenach
  4203, // Grellingen
  4445, // Häfelfingen
  4465, // Hemmiken
  4423, // Hersberg
  4434, // Hölstein
  4452, // Itingen
  4447, // Känerkinden
  4496, // Kilchberg (BL)
  4432, // Lampenberg
  4438, // Langenbruck
  4448, // Läufelfingen
  4242, // Laufen
  4415, // Lausen
  4426, // Lauwil
  4436, // Liedertswil
  4253, // Liesberg
  4254, // Liesberg Dorf
  4410, // Liestal
  4419, // Lupsingen
  4464, // Maisprach
  4142, // Münchenstein
  4132, // Muttenz
  4224, // Nenzlingen
  4435, // Niederdorf
  4453, // Nusshof
  4436, // Oberdorf (BL)
  4104, // Oberwil (BL)
  4494, // Oltingen
  4466, // Ormalingen
  4148, // Pfeffingen
  4133, // Pratteln
  4130, // Pratteln CALL
  4140, // Pratteln CIRCLE
  4135, // Pratteln INT
  4134, // Pratteln Sort
  4433, // Ramlinsburg
  4418, // Reigoldswil
  4153, // Reinach (BL)
  4462, // Rickenbach (BL)
  2814, // Roggenburg
  4244, // Röschenz
  4467, // Rothenfluh
  4444, // Rümlingen
  4497, // Rünenberg
  4124, // Schönenbuch
  4411, // Seltisberg
  4450, // Sissach
  4492, // Tecknau
  4456, // Tenniken
  4106, // Therwil
  4441, // Thürnen
  4425, // Titterten
  4246, // Wahlen
  4437, // Waldenburg
  4493, // Wenslingen
  4451, // Wintersingen
  4443, // Wittinsburg
  4495, // Zeglingen
  4417, // Ziefen
  4455, // Zunzgen
  4222, // Zwingen

  // Aargau
  4303, // Kaiseraugst
  4312, // Magden
  4313, // Möhlin
  4305, // Olsberg
  4310, // Rheinfelden

  // Solothurn
  4112, // Bättwil
  4413, // Büren
  4143, // Dornach
  4145, // Gempen
  4146, // Hochwald
  4114, // Hofstetten-Flüh
  4115, // Mariastein
  4116, // Metzerlen-Mariastein
  4412, // Nuglar-St.Pantaleon
  4118, // Rodersdorf
  4206, // Seewen
  4108, // Witterswil
  4252, // Bärschwil
  4229, // Beinwil
  4226, // Breitenbach
  4227, // Büsserach
  4228, // Erschwil
  4232, // Fehren
  4247, // Grindel
  4204, // Himmelried
  4245, // Kleinlützel
  4233, // Meltingen
  4208, // Nunningen
  4234, // Zullwil
];

const guaranteedCareHospitals: string[] = ['Universitätsspital Basel', 'USB', 'Bethesda'];
